import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Observable} from 'rxjs';
import {PageTitleStore, TitleDisplayState} from './page-title-store';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'app-page-title'},
  providers: [PageTitleStore],
  standalone: false,
})
export class PageTitleComponent {
  readonly vm$: Observable<TitleDisplayState> = this.store.vm$;
  constructor(private store: PageTitleStore) {}
}
